import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class RemoveWaitlistModal extends React.Component {
	state = {
		submitting: false
	};

	removeAttendees = async () => {
		const { orgId, eventId, group, existingWaitlist, checkedWaitlist } = this.props;

		const removingIds = Object.keys(checkedWaitlist);
		this.setState({ submitting: true });

		await API()
			.patch(`Organizations/${orgId}/events/${eventId}/groups/${group._id}`, {
				waitlist: existingWaitlist
					.filter((a) => !removingIds.includes(a._id))
					.map((a) => a._id)
			})
			.then((res) => {
				if (res.data) {
					this.props.removeWaitlistAttendees(removingIds);
					this.props.toggle();
				}
			})
			.catch((e) => {
				console.log(e);
				this.setState({ submitting: false });
			});
	};

	render() {
		const { isOpen, toggle, checkedWaitlist } = this.props;
		const { submitting } = this.state;
		const count = Object.keys(checkedWaitlist).length;

		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				modalTitle="Remove From Waitlist"
				bodyHeaderText={
					<span>
						You are about to remove{' '}
						<b>
							{count} attendee{count !== 1 && 's'}
						</b>{' '}
						from the waitlist. Would you like to continue?
					</span>
				}
				bodyContent={() => ''}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Remove' : 'Removing...'}
				actionButton={this.removeAttendees}
				actionButtonDisabled={submitting}
				isDelete={true}
			/>
		);
	}
}

export default RemoveWaitlistModal;
